export const createContext = process.env.BUILD_TARGET === 'client'
    ? require('./createClientContext').createContext
    : require('./createServerContext').createContext;
export const runWithContext = process.env.BUILD_TARGET === 'client'
    ? require('./createClientContext').runWithContext
    : require('./createServerContext').runWithContext;
export const isRunningWithContext = process.env.BUILD_TARGET === 'client'
    ? require('./createClientContext').isRunningWithContext
    : require('./createServerContext').isRunningWithContext;
